import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { getAvailableImageTypeToDisplay, getPostImageUrl, type PostImageType } from '../helpers/posts';
import { postAtomFamily } from '../posts';

interface UsePostImageProps {
    postId: string;
    imageType?: PostImageType;
}

export const usePostImage = (payload: UsePostImageProps) => {
    const { postId, imageType = 'featured' } = payload;

    const post = useAtomValue(postAtomFamily(postId));
    const availableImageType = useMemo(() => post && getAvailableImageTypeToDisplay(post, imageType), [post, imageType]);
    const imageUrl = useMemo(() => post && getPostImageUrl(post, availableImageType), [post, availableImageType]);
    const imageMetadata = post ? post[`${availableImageType}ImageMetadata`] : undefined;
    return { url: imageUrl, imageMetadata };
};
